import { enrollmentLink } from "./constants";
import { ParticipantEvent } from "../models/ParticipantEvent";

export function generateEnrollmentLink(
  event: ParticipantEvent,
  role: string
): string {
  return enrollmentLink(event.eventId, event.empId, getEnrollmentRole(role));
}

function getEnrollmentRole(role: string) {
  switch (role) {
    case "MEMBER":
      return "participant";
    default:
      return role;
  }
}
